(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.administration');
    /* main protocol service */
    module.factory('ProtocolService', ['$http', function ($http) {
        var baseUrl = '/api/protocols/';

        var service = {
            query: query,
            queryAll: queryAll,
            deactivate: deactivate,
            update: update,
            save: save
        };

        return service;

        /* get protocols for user */
        function query(userId, showAll, filter) {
            return $http({
                url: baseUrl + 'users/' + userId,
                method: 'GET',
                params: {
                    showAll: showAll ? showAll : false,
                    filter: filter ? filter : ''
                }
            }).then(function (response) {
                return response.data;
            });
        }

        /* get all protocols */
        function queryAll(showAll) {
            return $http({
                url: baseUrl,
                method: 'GET',
                params: {
                    showAll: showAll ? showAll : false
                }
            }).then(function (response) {
                return response.data;
            });
        }


        /* deactivate protocol */
        function deactivate(protocolId) {
            return $http.delete(baseUrl + protocolId).then(function (response) {
                return response.data;
            });
        }

        /* update protocol */
        function update(protocolId, item) {
            return $http.put(baseUrl + protocolId, item).then(function (response) {
                return response.data;
            });
        }

        /* save protocol */
        function save(item) {
            return $http.post(baseUrl, item).then(function (response) {
                return response.data;
            });
        }

    }]);
})();